import CryptoJS from 'crypto-js'

// 密钥（自己改一个复杂的）
const SECRET_KEY = 'myvueapp12345678';
const SECRET_IV = 'edcrfvtgbyhnujmi';

// 加密
export function encrypt(data) {
  const dataStr = typeof data === 'string' ? data : JSON.stringify(data)
  return CryptoJS.AES.encrypt(
    dataStr,
    CryptoJS.enc.Utf8.parse(SECRET_KEY),
    {
      iv: CryptoJS.enc.Utf8.parse(SECRET_IV),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  ).toString()
}

// 解密
export function decrypt(ciphertext) {
  try {
    const result = CryptoJS.AES.decrypt(
      ciphertext,
      CryptoJS.enc.Utf8.parse(SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(SECRET_IV),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      }
    ).toString(CryptoJS.enc.Utf8)
    return JSON.parse(result)
  } catch (e) {
    return e
  }
}